import React, { useEffect } from "react";
import { Stepper } from "components";
import { Box, Grid, Step, StepContent, StepLabel } from "@material-ui/core";
import { useSchemaProviderContext } from "hooks";
import { FormControls, FieldSelector } from "components/SchemaProvider";
import { useForm } from "react-hook-form";

interface SchemaFormProps {
    stepper: boolean;
}

export const SchemaForm = ({ stepper }: SchemaFormProps) => {
    const { reset } = useForm();
    const { isEdit, actionFields } = useSchemaProviderContext();

    useEffect(() => {
        if (isEdit) {
            const reduced = actionFields.reduce((fields, field) => {
                if (Array.isArray(field.value)) {
                    return {
                        ...fields,
                        [`${field.name}_Array`]: field.value.map((prop) => {
                            return {
                                id: prop.id,
                                name: prop.contactId,
                                value: prop.value,
                            };
                        }),
                    };
                }

                return {
                    ...fields,
                    [field.name]: field.value,
                };
            }, {});

            reset(reduced);
        }
    }, [isEdit, actionFields, reset]);

    return <form>{stepper ? <StepperSchema /> : <BasicSchema />}</form>;
};

const StepperSchema = () => {
    const { schema, groupFields } = useSchemaProviderContext();

    return (
        <Stepper orientation="vertical" style={{ padding: 0 }}>
            {schema.map(({ section, content }, schemaIndex) => {
                return (
                    <Step key={schemaIndex} active>
                        <StepLabel>{section}</StepLabel>
                        <StepContent>
                            {groupFields(content, 2).map((fieldGroup, groupIndex) => {
                                return (
                                    <Grid key={groupIndex} container spacing={1} alignItems="flex-start">
                                        {fieldGroup.map((fieldDefinition, fieldIndex) => {
                                            return (
                                                <Grid key={fieldIndex} xs={6} item>
                                                    <FieldSelector key={fieldIndex} {...fieldDefinition} />
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                );
                            })}
                        </StepContent>
                    </Step>
                );
            })}
            <FormControls />
        </Stepper>
    );
};

const BasicSchema = () => {
    const { schema, groupFields } = useSchemaProviderContext();

    return (
        <Box position="relative">
            {schema.map(({ content }, schemaIndex) => {
                return (
                    <Box key={schemaIndex}>
                        {groupFields(content).map((fieldGroup, groupIndex) => {
                            return (
                                <Grid key={groupIndex} container spacing={1}>
                                    {fieldGroup.map((fieldDefinition, fieldIndex) => {
                                        return (
                                            <Grid key={fieldIndex} xs={6} item>
                                                <Box pb={2} pr={1}>
                                                    <FieldSelector key={fieldIndex} {...fieldDefinition} />
                                                </Box>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            );
                        })}
                    </Box>
                );
            })}
            <FormControls />
        </Box>
    );
};
